/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_AchievementsInputs */

const id_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const ms_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const da_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const de_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften`)
};

const en_us2_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const es_es2_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const es_mx2_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const fil_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Achievement`)
};

const fr_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

const hu_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények`)
};

const nl_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties`)
};

const no_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjoner`)
};

const pl_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia`)
};

const pt_br2_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const pt_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const ro_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări`)
};

const fi_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutukset`)
};

const sv_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationer`)
};

const vi_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const tr_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlar`)
};

const cs_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěchy`)
};

const bg_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижения`)
};

const ru_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения`)
};

const uk_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення`)
};

const ar_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات`)
};

const hi_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ`)
};

const th_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ`)
};

const ja_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績`)
};

const zh_cn2_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const zh_hant1_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const ko_profile_hero_achievements = /** @type {(inputs: Profile_Hero_AchievementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Profile_Hero_AchievementsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_achievements = /** @type {((inputs?: Profile_Hero_AchievementsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_AchievementsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_achievements(inputs)
	if (locale === "ms") return ms_profile_hero_achievements(inputs)
	if (locale === "da") return da_profile_hero_achievements(inputs)
	if (locale === "de") return de_profile_hero_achievements(inputs)
	if (locale === "en-US") return en_us2_profile_hero_achievements(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_achievements(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_achievements(inputs)
	if (locale === "fil") return fil_profile_hero_achievements(inputs)
	if (locale === "fr") return fr_profile_hero_achievements(inputs)
	if (locale === "it") return it_profile_hero_achievements(inputs)
	if (locale === "hu") return hu_profile_hero_achievements(inputs)
	if (locale === "nl") return nl_profile_hero_achievements(inputs)
	if (locale === "no") return no_profile_hero_achievements(inputs)
	if (locale === "pl") return pl_profile_hero_achievements(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_achievements(inputs)
	if (locale === "pt") return pt_profile_hero_achievements(inputs)
	if (locale === "ro") return ro_profile_hero_achievements(inputs)
	if (locale === "fi") return fi_profile_hero_achievements(inputs)
	if (locale === "sv") return sv_profile_hero_achievements(inputs)
	if (locale === "vi") return vi_profile_hero_achievements(inputs)
	if (locale === "tr") return tr_profile_hero_achievements(inputs)
	if (locale === "cs") return cs_profile_hero_achievements(inputs)
	if (locale === "bg") return bg_profile_hero_achievements(inputs)
	if (locale === "ru") return ru_profile_hero_achievements(inputs)
	if (locale === "uk") return uk_profile_hero_achievements(inputs)
	if (locale === "ar") return ar_profile_hero_achievements(inputs)
	if (locale === "hi") return hi_profile_hero_achievements(inputs)
	if (locale === "th") return th_profile_hero_achievements(inputs)
	if (locale === "ja") return ja_profile_hero_achievements(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_achievements(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_achievements(inputs)
	return ko_profile_hero_achievements(inputs)
});
export { profile_hero_achievements as "profile.hero.achievements" }